<template>
	<div>
		<layout-12
			:table_name="'Job Orders'"
			:filter_options=filters
			:auto_reload=false
			:id=pageid
			:term=term
			:reroute="'0318'"
			:buttonnames="['Add To Port Stay']"
			:buttonperms="['82']"
			:buttonnamefunction="['add']"
			v-on:button="button"
			v-on:select="select"
			style="width:100%; height:calc(100vh - 50px);">
		</layout-12>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.JOBORDER_PORT_STAYS_PAGE,
			filters:[
				{name:"Status", options:["Open","Completed","Cancelled"], value:[true,true,false], permission:['52','53','54']},
				{name:"Date", options:["Start","End"], value:['',''], permission:null},
				{name:"Has PortStay", options:["Not Empty","Empty"], value:[false,false], permission:null},
			]
		}
	},
	methods: {
		button(buttonname, selectedIndexs, column_data){
			if(buttonname=='add'){
				this.add(selectedIndexs, column_data);
			}
		},
		add(selectedIndexs, column_data){
			if(selectedIndexs.length>0){
				var joborders = [];
				for(let i = 0;i<selectedIndexs.length;i++){
					joborders.push(column_data[selectedIndexs[i]][0]);
				}
				router.push('/0409?q='+joborders);
				//router.go(0)
			}
		},
		select(selectedIndexs, column_data){
			if(selectedIndexs.length>0){
				var joborders = [];
				for(let i = 0;i<selectedIndexs.length;i++){
					joborders.push(column_data[selectedIndexs[i]][0]);
				}
				router.push('/0409?q='+joborders);
				//router.go(0)
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/view/Job_Order_Port_Stays.vue